<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'体检报告'" :fixed="true"> </Nav>
      <div class="top"></div>
    </div>

    <div class="head">
      <div class="title_head">
        <div class="title_head_name">{{ pereport.Name }}</div>
        <div class="title_head_age">
          <span class="geary">年龄：</span>{{ pereport.Age }}岁
        </div>
      </div>
      <div class="head_row">
        <span class="geary">报告ID：</span>{{ pereport.ReportId }}
      </div>
      <div class="head_row"  v-if="State>=4&&State<=99">
        <span class="geary">报告日期：</span>{{ ReportDate }}
      </div>
    </div>
    <div class="body">
      <div class="Suggestion" style="white-space:pre-line">
        体检总结结论：
        {{ pereport.Summarize }}
      </div>
      <div class="Suggestion" style="white-space:pre-line">
        体检结论建议：
        {{ pereport.Suggestion }}
      </div>
      <div class="Summarize" style="white-space:pre-line">科普说明：{{ pereport.Science }}</div>
      <div
        class="bodylisat"
        v-for="item in pereportlist"
        :key="item[0].ComboID"
      >
        <div class="indexcard" v-if="item[0].LisSacs == 0">
          <van-row type="flex" justify="center" class="cardtitle">
            <van-col span="24">{{ item[0].ComboName }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" class="cartdhead">
            <van-col span="8" class="cardcol">项目名称</van-col>
            <van-col span="8" class="cardcol" style="border-left:solid 1px #b8ebff;border-right:solid 1px #b8ebff">项目结果</van-col>
            <van-col span="8" class="cardcol">单位</van-col>
          </van-row>
          <van-row
            justify="center"
            v-for="(item1, index) in item"
            :key="item1.ComboID + index"
            class="itemrow"
          >
            <van-col span="8" class="cardcol">{{ item1.ItemName }}</van-col>
            <van-col span="8" class="cardcol" style="border-left:solid 1px #b8ebff;border-right:solid 1px #b8ebff">{{ item1.Result }}</van-col>
            <van-col span="8" class="cardcol">{{ item1.Unit?item1.Unit:"/" }}</van-col>
          </van-row>
            <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">小结：{{ item[0].Summary }}</van-col>
          </van-row>
                <van-row type="flex" justify="center" class="cardfoot">
              <van-col span="24">检查医生：{{ item[0].DoctorName }}</van-col>
                <van-col span="24">检查日期：{{ item[0].CheckDate.substring(0,10) }}</van-col>
            </van-row>
        </div> 
        <div class="onecard" v-if="item[0].LisSacs == 1">
           <van-row type="flex" class="cardtitle">
            <van-col span="24">{{ item[0].ComboName }}</van-col>
          </van-row>
          <van-row type="flex" class="cartdhead">
            <van-col span="7" class="cardcol">名称</van-col>
            <van-col span="4" class="cardcol" style="border-left:solid 1px #b8ebff;border-right:solid 1px #b8ebff">结果</van-col>
            <van-col span="4" class="cardcol" style="border-left:solid 1px #b8ebff;border-right:solid 1px #b8ebff">单位</van-col>
             <van-col span="6" class="cardcol" style="border-left:solid 1px #b8ebff;border-right:solid 1px #b8ebff">参考值</van-col>
               <van-col span="3" class="cardcol" style="border-left:solid 1px #b8ebff;border-right:solid 1px #b8ebff">提示</van-col>
          </van-row>
          <van-row
            justify="center"
            v-for="(item1, index) in item"
            :key="item1.ComboID + index"
            class="oneitemrow"
          >
            <van-col span="7" class="cardcol">{{ item1.ItemName }}</van-col>
            <van-col span="4" class="cardcol" >{{ item1.Result }}</van-col>
            <van-col span="4" class="cardcol" >{{ item1.Unit?item1.Unit:"/" }}</van-col>
               <van-col span="6" class="cardcol" >{{ item1.Reference  }}</van-col>
                <van-col span="3" class="cardcol">{{ item1.Hint  }}</van-col>
          </van-row>
            <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">小结：{{ item[0].Summary }}</van-col>
          </van-row>
              <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">检查医生：{{ item[0].DoctorName }}</van-col>
               <van-col span="24">检查日期：{{ item[0].CheckDate.substring(0,10) }}</van-col>
          </van-row>
        </div>
        <div class="twocard" v-if="item[0].LisSacs == 2">
              <van-row type="flex" class="cardtitle">
            <van-col span="24">{{ item[0].ComboName }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">检查部位：{{ item[0].CheckPart }}</van-col>
          </van-row>
           <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">检查所见：{{ item[0].CheckContent  }}</van-col>
          </van-row>
            <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">小结：{{ item[0].Summary }}</van-col>
          </van-row>
              <van-row type="flex" justify="center" class="cardfoot">
            <van-col span="24">检查医生：{{ item[0].DoctorName }}</van-col>
               <van-col span="24">检查日期：{{ item[0].CheckDate.substring(0,10) }}</van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
export default {
  data() {
    return {
      PersonalNo: "",
      CheckupNo: "",
      pereport: [],
      pereportlist: [],
      ReportDate:"",
      State:null
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.PersonalNo = this.$route.query.PersonalNo;
    this.CheckupNo = this.$route.query.CheckupNo;
    this.State=this.$route.query.State
    this.getpedetail();
  },
  methods: {
    getjsoninfo(arr) {
      let obj = [];
      let newjson = arr; 
      let onlykeys = [];
      newjson.forEach((item) => {
        if (onlykeys.indexOf(item.ComboName) == -1) {
          onlykeys.push(item.ComboName);
        }
      });
      onlykeys.forEach((item) => {
        let c = [];
        newjson.forEach((item1) => {
          if (item1.ComboName == item) {
            c.push(item1);
          }
        });
        obj.push(c);
      });
      console.log(obj)
      return obj;
    },
    async getpedetail() {
      try {
        this.$showLoad();
        let url = "/peisprecontroller/PEISQueryPersonalInfoReport";
        let R_data = {
          PersonalNo: this.PersonalNo,
          CheckupNo: this.CheckupNo,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          R_data,
          (data) => {
            this.pereport = data.data.data.Data;
            this.pereportlist = this.getjsoninfo(this.pereport.Results);
            this.ReportDate=this.pereportlist[0][0].TotalCheckupDate          
          // this.ReportDate.substring()
              // console.log(this.pereport)
            if (this.pereport.length === 0) {
              this.showempty = true;
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100vh;
  background-color: #f7f7f7;

  .nav {
    height: 6vh;
    .top {
      height: 50px;
    }
  }
  .head {
    width: 100%;
    background-color: #5b8df6;
    height: 17vh;
    display: flex;
    flex-direction: column;
    color: white;
    padding: 15px;
    .title_head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 6vh;
      .title_head_name {
        font-size: 25px;
      }
      .title_head_age {
        font-size: 14px;
      }
    }
    .head_row {
      font-size: 14px;
      line-height: 4vh;
      color: #ffffff;
    }
  }
  .body {
    display: flex;
    flex-direction: column;
    height: 80vh;
    overflow-y: auto;
    .Suggestion {
      width: 95%;
      margin: 0 auto;
      padding: 3%;
      border: 1px solid #5b8df6;
      margin-bottom: 2vh;
      margin-top: 2vh;
      border-radius: 10px;
      background-color: #ffffff;
    }
    .Summarize {
      width: 95%;
      margin: 0 auto;
      padding: 3%;
      border: 1px solid #5b8df6;
      border-radius: 10px;
      background-color: #ffffff;
      margin-bottom: 5vh;
    }
    .bodylisat {
      padding: 10rx;
      color: #333;
      font-size: 15px;
      .indexcard{
        width: 95%;
        margin: 0 auto;
        margin-bottom: 3vh;
         background-color: #ffffff;
      }
      .onecard{
          width: 95%;
        margin: 0 auto;
        margin-bottom: 3vh;
         background-color: #ffffff;
      }
      .twocard{
    width: 95%;
        margin: 0 auto;
        margin-bottom: 3vh;
         background-color: #ffffff;
      }
      .cardfoot{
            border-bottom:1px solid #b8ebff;
              line-height: 4vh;
      }
      .cardtitle{
        background-color: #b8ebff;
        text-align: center;
      }
      .cartdhead{
         line-height: 6vh;
        background-color: #ffffff;
          border-bottom:1px solid #b8ebff;
      }
      .cardcol{
          text-align: center;
          background-color: #ffffff;
      }
      .itemrow{
        border-bottom:1px solid #b8ebff;
        line-height: 5vh;
      }
      .oneitemrow{
           border-bottom:1px solid #b8ebff;
        line-height: 4vh;
      }
    }
  }
}
</style>